import { Reducer } from 'redux';
import {
  FundraisingTransaction,
  FundraisingTransactionsModelList,
} from 'src/models/FundraisingModel';
import {
  ADD_FUNDRAISING_TX,
  REMOVE_FUNDRAISING_TX,
} from 'src/redux/actions/FundraisingTransactionAction';

export type FundraisingTransactionsList = FundraisingTransactionsModelList;

const DEFAULT = {} as FundraisingTransactionsList;

const FundraisingTransactionsReducer: Reducer<FundraisingTransactionsList> = (state = DEFAULT, action) => {
  switch (action.type) {
    case ADD_FUNDRAISING_TX: {
      const { id, transaction } = action.payload;
      return {
        ...state,
        [id]: transaction as FundraisingTransaction,
      };
    }
    case REMOVE_FUNDRAISING_TX: {
      const id = action.payload;
      const { [id]: removedFundraising, ...remainingFundraising } = state;
      return {
        ...remainingFundraising,
      };
    }
    default:
      return state;
  }
};

export default FundraisingTransactionsReducer;
